const enumList = require('./enumList');

module.exports = enumList.reduce((memo, i) => ({ ...memo, [i]: { id: i, label: i } }), {});
